module.exports = __webpack_public_path__ + "img/atlas_1000ml.decce162.png";